/*
 *
 * NotificationScreen reducer
 *
 */
import {produce} from 'immer';
import { DEFAULT_ACTION } from './constants';
import * as constants from './constants';

export const initialState = {
    error: 0,
    error_msg: '',
    loading: false,
    notifications: [{
      subject: "test",
      date_create: new Date(),
      body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
    },{
      subject: "test",
      date_create: new Date(),
      body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
    },{
      subject: "test",
      date_create: new Date(),
      body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
    },{
      subject: "test",
      date_create: new Date(),
      body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
    },{
      subject: "test",
      date_create: new Date(),
      body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
    }]
};

/* eslint-disable default-case, no-param-reassign */
const NotificationScreenReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case DEFAULT_ACTION:
        break;
      case constants.UPDATE_INPUT:
        draft[action.name] = action.value;
        break;
      case constants.GET_NOTIFICATIONS:
        draft.loading = true;
        break;
      case constants.GET_NOTIFICATIONS_FAIL:
        draft.error = true;
        draft.loading = false;
        break;
      case constants.GET_NOTIFICATIONS_LOADING:
        draft.loading = true;
        break;
      case constants.GET_NOTIFICATIONS_SUCCESS:
        draft.notifications = action.results;
        draft.loading = false;
        break;
    }
  });

export default NotificationScreenReducer;
